import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Box,
  IconButton,
  useScrollTrigger
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';


// Sayfa kaydırma durumunu algılar
function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    sx: {
      backgroundColor: trigger ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.95)',
      transition: '0.3s',
      backdropFilter: 'blur(8px)'
    }
  });
}

const Layout = ({ children }) => {
  // useTheme kaldırıldı: footer arka planı inline theme callback ile hesaplanıyor
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  // Ana sayfaya dön
  const handleNavigateHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ElevationScroll>
        <AppBar position="sticky" color="default">
          <Toolbar>
            {isHomePage ? (
              // Ana sayfada sadece logo göster
              <Box 
                component="img" 
                src="/logo.png" 
                alt="D-CAT Logo" 
                sx={{ 
                  height: 100, 
                  cursor: 'pointer',
                  borderRadius: 0 // Logoyu düz göster, yuvarlak yapmadan
                }}
                onClick={handleNavigateHome}
              />
            ) : (
              // İç sayfalarda geri butonu ve logo göster
              <>
                <IconButton 
                  edge="start" 
                  color="inherit" 
                  onClick={handleNavigateHome} 
                  sx={{ mr: 2 }}
                >
                  <HomeIcon />
                </IconButton>
                <Box 
                  component="img" 
                  src="/logo.png" 
                  alt="D-CAT Logo" 
                  sx={{ 
                    height: 40, 
                    cursor: 'pointer',
                    borderRadius: 0 // Logoyu düz göster, yuvarlak yapmadan
                  }}
                  onClick={handleNavigateHome}
                />
              </>
            )}
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          textAlign: 'center',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
        }}
      >
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} D-CAT Analytics
        </Typography>
      </Box>
    </Box>
  );
};

export default Layout;
